import { LegalPage, LegalSection, LEGAL } from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalPage subtitle="Legal" title="Política de Cookies">
      <LegalSection title="1. ¿Qué son las cookies?">
        <p>Las cookies son pequeños archivos que se almacenan en tu dispositivo al visitar un sitio web y permiten su correcto funcionamiento.</p>
      </LegalSection>

      <LegalSection title="2. Cookies que utilizamos">
        <p>En este sitio <strong className="text-zinc-200">solo utilizamos cookies técnicas propias</strong>, estrictamente necesarias para el funcionamiento de la web y del área privada. <strong className="text-zinc-200">No usamos cookies analíticas, de perfilado ni publicitarias</strong>, ni compartimos información con terceros con fines comerciales.</p>
        <div className="overflow-x-auto mt-2">
          <table className="w-full text-sm border border-white/10 rounded-lg overflow-hidden">
            <thead className="bg-white/5 text-zinc-300">
              <tr>
                <th className="text-left px-4 py-2 font-medium">Cookie</th>
                <th className="text-left px-4 py-2 font-medium">Finalidad</th>
                <th className="text-left px-4 py-2 font-medium">Duración</th>
              </tr>
            </thead>
            <tbody className="text-zinc-400">
              <tr className="border-t border-white/5">
                <td className="px-4 py-2 font-mono">anv_token</td>
                <td className="px-4 py-2">Mantener la sesión iniciada en el área privada (autenticación).</td>
                <td className="px-4 py-2">Sesión</td>
              </tr>
              <tr className="border-t border-white/5">
                <td className="px-4 py-2 font-mono">anv_cookie_ack</td>
                <td className="px-4 py-2">Recordar que has visto el aviso de cookies.</td>
                <td className="px-4 py-2">1 año</td>
              </tr>
            </tbody>
          </table>
        </div>
      </LegalSection>

      <LegalSection title="3. Consentimiento">
        <p>Al tratarse exclusivamente de cookies técnicas necesarias, conforme al artículo 22.2 de la LSSI-CE están exentas de la obligación de recabar consentimiento. Aun así, te informamos de su uso mediante el aviso que aparece al entrar en la web.</p>
      </LegalSection>

      <LegalSection title="4. Cómo desactivar las cookies">
        <p>Puedes configurar tu navegador para bloquear o eliminar las cookies. Ten en cuenta que, si desactivas las cookies técnicas, el área privada podría no funcionar correctamente. Consulta la ayuda de tu navegador (Chrome, Firefox, Safari, Edge) para gestionar estas opciones.</p>
      </LegalSection>

      <LegalSection title="5. Contacto">
        <p>Si tienes dudas sobre esta política, escríbenos a <a className="text-[#D4AF37]" href={`mailto:${LEGAL.email}`}>{LEGAL.email}</a>.</p>
      </LegalSection>
    </LegalPage>
  );
}
